import script from "./PosTerminalSelectorDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PosTerminalSelectorDialog.vue?vue&type=script&setup=true&lang=js"

import "./PosTerminalSelectorDialog.vue?vue&type=style&index=0&id=96bceb18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96bceb18"]])

export default __exports__